export enum EventType {
    Online = 1,
    Offline = 2,
}
